<template>
    <div>
      <div id="page-header">
        <img v-bind:src="brewery.imageURL" />
        <div class="brewery-info">
            <h2>{{ brewery.breweryName }}</h2>
            <h3 id="address"><i class="fa-solid fa-location-dot blue"></i> {{ brewery.address }}</h3>
          <h3><i class="fa-solid fa-phone blue"></i> {{ brewery.phoneNumber }}</h3>
          <h3 id="hours"><i class="fa-solid fa-clock blue"></i> {{brewery.hours}}</h3>
          <h4 v-if="this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId)===0">No Ratings</h4>
        <h4 v-if="this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId)!==0">Average Rating: {{this.$store.getters.getAverageRatingForBreweryId(brewery.breweryId)}}<i class="fa-solid fa-star"></i> | {{this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId)}} Review<span v-if="this.$store.getters.getNumberOfReviewsByBreweryId(brewery.breweryId)>1">s</span></h4>
        </div>
      </div>
      <div id="page-main">
        <h2>Our History</h2>
        <p>{{ brewery.description }}</p>
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    
    name: "brewery-detail",
    data() {
      return {
        errorMsg: "",
        paramsId: parseInt(this.$route.params.id),
      };
    },
    computed: {
        brewery () {
            return this.$store.getters.getBreweryById(this.paramsId)
        }
    }
  };
  </script>